<template>
  <div id="dataAnalysis" class="fromPage">
    <div class="title_page">数据分析</div>
    <!-- 头部搜索 -->
    <el-row>
      <div class="flexStart">
        <div class="title_table">时间维度</div>
        <el-date-picker v-model="param.times" type="datetimerange" align="right" unlink-panels range-separator="至" value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
          style="width: 50%;">
        </el-date-picker>
      </div>
    </el-row>
    <el-row>
      <div class="flexStart">
        <div class="title_table">行业维度</div>
        <el-cascader ref="tradeList" v-model="selected_trade" :options="tradeList" :props="props_cascader" clearable @change="refreshData"
          placeholder="请选择目前所涉及的行业" style="width: 50%;"></el-cascader>
      </div>
    </el-row>
    <el-row>
      <div class="flexStart">
        <div class="title_table">企业维度</div>
        <el-select-tree ref='selectTree' :props="props_user" :dataArray="enterprieList" :value="selected_user" :clearable="isClearable" :accordion="isAccordion"
          placeholder="请选择企业" @getValue="getSelectedValue"  style="width: 50%;"/>
      </div>
    </el-row>
    <el-row>
      <div class="flexStart">
        <div class="title_table">指标维度</div>
        <el-select v-model="selected_index" multiple placeholder="请选择指标维度" size="small" :popper-append-to-body="false" clearable @change="refreshData" style="width: 50%;">
          <el-option v-for="item in indexList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
    </el-row>
    <!-- 统计分析 -->
    <div class="echartsBox">
      <!-- 柱状图 -->
      <el-row style="margin-bottom:10px">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="bgContent" id="barChart_avg" style="width: 95%; height: 300px"></div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="bgContent" id="barChart_total" style="width: 95%; height: 300px"></div>
        </el-col>
      </el-row>
      <!-- 折线图 -->
      <el-row>
        <div class="bgContent" id="lineChart" style="width: 100%; height: 300px"></div>
      </el-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import echarts from "echarts/lib/echarts";
import elSelectTree from "../../components/selectTree.vue";
export default {
  name: "dataAnalysis",
  components: { elSelectTree },
  data() {
    return {
      moment: moment,
      param: {
        times: [],
        keyWords: "",
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      tradeList: [],// 行业合集
      enterprieList: [],//企业合集
      indexList: [],
      props_cascader: {
        expandTrigger: 'hover',
        multiple: true,
        label: 'name',
        value: 'id',
        children: 'industryCategoryList',
      },
      // selectTree
      isClearable: true, // 可清空（可选）
      isAccordion: true, // 可收起（可选）
      props_user: {
        value: "id",
        label: 'enterprieName',
        children: 'userList'
      },
      selected_trade: [],
      selected_user: [],
      selected_index: [],
      // 图表
      initEachart: {
        qiisChart_avg: null,//平均
        option_avg: null,
        qiisChart_total: null,//总体
        option_total: null,
        qiisChart_line: null,//综合
        option_line: null,
      },
    };
  },
  created() {
    this.getIndustryTypes();
  },
  mounted() {
    this.getUserList_tree();
    this.initChart();
    this.refreshData();
  },
  methods: {
    //获取目前所涉及的行业
    getIndustryTypes() {
      this.$axios
        .post(`${process.env.BASE_URL}api/industry/industryList`, { keyWords: '', page: 1, limit: 999999, isUse: 1 })
        .then((res) => {
          if (res.data.code === 200) {
            this.tradeList = Object.assign([], res.data.page.list);
          } else {
            this.$message({
              type: "error",
              message: "查询失败-" + res.data.msg,
              offset: 80,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取用户组织树
    getUserList_tree() {
      this.$axios
        .post(`${process.env.BASE_URL}api/user/userOrganization`,
          { keyWords: '', page: 1, limit: 999999, tier: '', registerMail: '' })
        .then((res) => {
          if (res.data.code === 200) {
            this.enterprieList = Object.assign([], res.data.page.list);
          } else {
            this.$message({
              type: "error",
              message: "查询失败-" + res.data.msg,
              offset: 80,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取图表数据-请求
    getChartData() {
      this.initEachart.option_avg.xAxis[0].data = ['集团A', '集团B', '集团C', '集团D', '集团E', '集团F', '集团G', '集团H'];
      this.initEachart.option_avg.series[0].data = [9.8, 9, 7, 6, 5, 4.5, 4, 3];
      this.initEachart.qiisChart_avg.setOption(this.initEachart.option_avg);
      this.initEachart.option_total.xAxis[0].data = ['行业E', '行业F', '行业D', '行业C', '行业A', '行业B'];
      this.initEachart.option_total.series[0].data = [4.8, 5, 6, 7, 9, 9.6];
      this.initEachart.qiisChart_total.setOption(this.initEachart.option_total);
      this.initEachart.option_line.xAxis.data = ['指标E', '指标F', '指标D', '指标C', '指标A', '指标B', '指标G', '指标H', '指标I', '指标J'];
      this.initEachart.option_line.series[0].data = [9.8, 8.5, 7, 6, 5, 5.6, 7, 8, 9, 5.7];
      this.initEachart.qiisChart_line.setOption(this.initEachart.option_line);
    },
    // 整体刷新数据
    refreshData() {
      this.param.keyWords = "";
      this.getChartData();
    },
    // 树状选择
    getSelectedValue(value, name) {
      this.param.typeId = null;
      if (typeof value == "number") {
        this.selected_user = value;
        this.refreshData();
      }
      if (!value) {
        this.selected_user = [];
        this.refreshData();
      }
    },
    // 初始化 echarts
    initChart() {
      let option_line = (titleAll, title) => {
        return {
          title: {
            text: titleAll,
            textStyle: {
              color: "#000000",
              fontSize: 16,
            },
            right: 'center'
          },
          //图表离容器的距离
          grid: {
            top: '10%',
            bottom: '10%',
            containLabel: true,
          },
          legend: { bottom: 5 },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          //X轴
          xAxis: {
            type: "category",
            data: [],
            axisLabel: {
              textStyle: {
                color: "#60616F",
                fontSize: 12,
              },
            },
            axisTick: {
              show: false, //隐藏X轴刻度尺
            },
          },
          //y轴
          yAxis: {
            type: "value",
            name: title,
            splitLine: { show: true },
            axisLabel: {
              textStyle: {
                color: "#60616F",
                fontSize: 12,
              },
            },
          },
          series: [
            {
              name: title,
              type: "line",
              data: [],
              itemStyle: { color: "#3E7BFA" },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: "rgba(80, 135, 236, 0.3)",
                      },
                      {
                        offset: 0.8,
                        color: "rgba(80, 135, 236, 0)",
                      },
                    ],
                    false
                  ),
                  shadowColor: "rgba(0, 0, 0, 0.1)",
                  shadowBlur: 10,
                },
              },
            },
          ],
        };
      };
      let option_bar = (titleAll, title, color1, color2) => {
        return {
          title: {
            text: titleAll,
            textStyle: {
              color: "#000000",
              fontSize: 16,
            },
            right: 'center'
          },
          grid: [
            {
              top: "10%",
              bottom: "10%",
              containLabel: true,
            },
          ],
          legend: {
            bottom: 0,
            data: [title],
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            }
          },
          //X轴
          xAxis: [
            {
              type: "category",
              data: [],
            },
          ],
          yAxis: [
            {
              type: "value",
              axisLabel: {
                formatter: function (v) {
                  return v > 0 ? v : -v;
                },
              },
            },
          ],
          series: [
            {
              name: title,
              type: "bar",
              barWidth: 15,
              data: [],
              itemStyle: {
                normal: {
                  barBorderRadius: [20, 20, 0, 0],
                  borderColor: color1,
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: color1 },
                    { offset: 0, color: color2 },
                  ]),
                },
              },
            }
          ],
        };
      };
      // 指标平均得分
      this.initEachart.option_line = option_line('不同指标所有企业总金额评分综合统计', '指标平均得分');
      this.initEachart.qiisChart_line = new this.QiisChart(["lineChart", this.initEachart.option_line]);
      this.$nextTick(() => { this.initEachart.qiisChart_line.resize(); });
      // 平均
      this.initEachart.option_avg = option_bar('各集团2023年度指标平均得分排名统计', '企业平均得分', '#5087ec', '#5087ec');
      this.initEachart.qiisChart_avg = new this.QiisChart(["barChart_avg", this.initEachart.option_avg]);
      this.$nextTick(() => { this.initEachart.qiisChart_avg.resize(); });
      // 总体
      this.initEachart.option_total = option_bar('各行业企业总体分数统计', '行业总体得分', '#85c092', '#85c092');
      this.initEachart.qiisChart_total = new this.QiisChart(["barChart_total", this.initEachart.option_total]);
      this.$nextTick(() => { this.initEachart.qiisChart_total.resize(); });
    },
  },
};
</script>
<style lang='less' scoped>
.title_page {
  margin-bottom: 10px;
}

.title_table {
  margin: 15px 20px 15px 0px;
}
.echartsBox {
  margin: 20px;
  margin-bottom: 60px;

  > div {
    display: flex;
    justify-content: space-between;
  }

  .title {
    height: 23px;
    position: relative;
    padding-left: 10px;
    color: #000;
    font-size: 15px;
    font-weight: 500;
    line-height: 150%;
    /* 22.5px */
    letter-spacing: 0.6px;

    &::after {
      content: "";
      position: absolute;
      left: 0px;
      width: 4px;
      height: 80%;
      top: 2%;
      background: #505869;
    }
  }
}
</style>
<style lang="less">
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
}
</style>